import { combineReducers } from 'redux';
import Puzzle15 from './Puzzle15.reducer';

export const rootReducer = combineReducers({
  Puzzle15
});
